export default "__VITE_ASSET__CKBjRt61__"